import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAppSelector } from '../redux/hook'
import { selectAuth } from '../redux/slices/authSlice'
import { Landing } from '../features/misc/routes'
import { Forgot, Login, Logout, ResetPassword } from '../features/auth/routes'
import { Brands, Holiday } from '../features/brands/routes'
import Dashboard from '../features/dashboard/pages'
// import Profile from '../features/profile/pages'
import MgrDashboard from '../features/dashboard/managerdashboard/pages'
import TeacherDashboard from '../features/teacherdashboard/pages'
import ChangePassword from '../features/profile/changepassword/pages'
import EditProfile from '../features/profile/editprofile/pages'
import ImportantInfo from '../features/impinfo/pages'
import UploadItem from '../features/impinfo/uploaditem/pages'
import Users from '../features/userslisting/pages'
import TimeRequests from '../features/timeoffreq/pages'
import ViewRequest from '../features/timeoffreq/viewrequest/pages'
import Announcements from '../features/announcements/pages'
import PostAnnouncement from '../features/announcements/postannouncement/pages'
import ApplyTimeoffrequest from '../features/timeoffreq/applytimeoff/pages'
import Applyrequest from '../features/timeoffreq/details/pages'
import SyncUser from '../features/userslisting/sync/pages'
import Viewuser from '../features/userslisting/viewuser/pages'
import ViewEmp from '../features/dashboard/managerdashboard/view/pages'
import EmpDetails from '../features/dashboard/managerdashboard/details/pages'
import AddTime from '../features/dashboard/managerdashboard/view/addtime/pages'
import LeavePolicy from '../features/leavepolicy/pages'
import EditPolicy from '../features/leavepolicy/editpolicy/pages'
import Usercreated from '../features/userslisting/createuser/pages/user-created'
import Signup from '../features/userslisting/createuser/pages'
import EmpFiles from '../features/emp-files/pages'
import UploadFile from '../features/emp-files/uploadfile/pages'
import LeaveTypes from '../features/leavepolicy/leavetypes/pages'
import Resources from '../features/resources/pages'
import Forms from '../features/forms/pages'
import UploadForm from '../features/forms/uploadform/pages'
import AssignUsers from '../features/forms/assignusers/pages'
import FormTable from '../features/forms/teacherform/formtable/pages'
import EmpResources from '../features/resources/empresources/resourcetable/pages'
import ViewResource from '../features/resources/empresources/viewresource/pages'
import Questionnaire from '../features/resources/empresources/questionnaire/pages'
import AssignResources from '../features/resources/assignuser/pages'
import ExploreResource from '../features/resources/viewresources/pages'
import UploadResources from '../features/resources/upload/pages'
import CreateQuestion from '../features/resources/viewresources/createquestion/pages'
import SyncTable from '../features/userslisting/sync/synctable/pages'
import DirectorDashboard from '../features/dashboard/directordashboard/pages'
import Notification from '../features/notification/pages'
export const PageRoute = {
    NotFound: '*',
    Forgot: '/auth/forgot',
    Login: '/',
    ResetPassword: '/account/reset-password',
    Signup: '/users/add-new',
    Usercreated: '/users/user-created',
    Brands: '/brands',
    Profile: '/profile',
    Logout: '/logout',
    Landing: '/landing',
    Holidays: '/holidays',
    Dashboard: '/dashboard',
    DashboardView: '/dashboard/view',
    MgrDashboard: '/manager/dashboard',
    Teacher: '/teacher/dashboard',
    ChangePass: '/profile/changepassword',
    EditProfile: '/profile-edit',
    Info: '/imp-info',
    InfoItemUpload: '/imp-info/upload',
    Users: '/users',
    Requests: '/timeoffreq',
    ViewRequest: '/timeoffreq/view',
    Announcements: '/announcements',
    PostAccments: '/announcements/create',
    Details: '/time-off',
    ApplyReq: '/details/apply-req',
    SyncUser: '/sync/user',
    ViewUser: '/users/view',
    ViewEmpDetail: '/dashboard/view/emp-detail',
    AddTimeRequest: '/dashboard/add-time',
    LeavePolicy: '/leave-policies',
    EditPolicy: '/leave-policies/edit/:id',
    Files: '/emp/files',
    FileUpload: '/emp/files/upload',
    FileEdit: '/emp/files/edit/:id',
    LeaveTypes: '/leave-policies/add-type',
    Resouces: '/resources',
    Forms: '/forms',
    UplaodForm: '/forms/upload',
    EditForm: '/forms/edit/:id',
    AssignUserForm: '/forms/assign',
    EmployeeForm: '/teacher/forms',
    EmployeeResouces: '/teacher/resources',
    ViewResouce: '/teacher/resources-view/:id',
    Questions: '/teacher/resources/questions/:id',
    AssignResouces: '/resources/assign',
    ExporeResource: '/resources/view/:id',
    UploadRsrc: '/resources/upload',
    CreateQues: '/resources/create-question/:id',
    OtherTimeReq: '/users/apply-timeoff',
    UserPassword: '/users/user/change-password/:id',
    SynCalendar: '/sync',
    EmployeeList: '/teacher/employees',
    ViewUserProfile: '/dashboard/view-profile',
    ReqView: '/time-off/view/:id',
    Apply: '/time-off/apply',
    ManagerViewProfile: '/teachers/view',
    Notification: '/notification',
}
const publicRoutes = [
    // { path: PageRoute.Landing, element: <Landing /> },
    { path: PageRoute.Login, element: <Login /> },
    { path: PageRoute.Landing, element: <Landing /> },

    { path: PageRoute.Forgot, element: <Forgot /> },
    { path: PageRoute.ResetPassword, element: <ResetPassword /> },
    { path: PageRoute.Logout, element: <Logout /> },
    {
        path: PageRoute.NotFound,
        element: <Navigate to={PageRoute.Login} replace />,
    },
]
const protectedRoutes = [
    { path: PageRoute.Dashboard, element: <Dashboard />, roles: ['admin'] },
    {
        path: PageRoute.Dashboard,
        element: <MgrDashboard />,
        roles: ['manager'],
    },
    {
        path: PageRoute.Dashboard,
        element: <DirectorDashboard />,
        roles: ['executivedirector'],
    },
    {
        path: PageRoute.Dashboard,
        element: <TeacherDashboard />,
        roles: ['teacher'],
    },
    {
        path: PageRoute.ChangePass,
        element: <ChangePassword />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.EditProfile,
        element: <EditProfile />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Brands,
        element: <Brands />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Profile,
        element: <Viewuser />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.ViewUserProfile,
        element: <Viewuser />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.ManagerViewProfile,
        element: <Viewuser />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.Holidays,
        element: <Holiday />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Info,
        element: <ImportantInfo />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.InfoItemUpload,
        element: <UploadItem />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Users,
        element: <Users />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Requests,
        element: <TimeRequests />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.ViewRequest,
        element: <ViewRequest />,
        roles: ['admin', 'manager', 'teacher', 'executivedirector'],
    },
    {
        path: PageRoute.ReqView,
        element: <ViewRequest />,
        roles: ['admin', 'manager', 'teacher', 'executivedirector'],
    },
    {
        path: PageRoute.Announcements,
        element: <Announcements />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.PostAccments,
        element: <PostAnnouncement />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Details,
        element: <ApplyTimeoffrequest />,
        roles: ['manager', 'teacher', 'executivedirector'],
    },
    {
        path: PageRoute.EmployeeList,
        element: <ViewEmp />,
        roles: ['manager', 'executivedirector'],
    },
    {
        path: PageRoute.ApplyReq,
        element: <Applyrequest />,
        roles: ['admin', 'manager', 'teacher', 'executivedirector'],
    },
    {
        path: PageRoute.Apply,
        element: <Applyrequest />,
        roles: ['manager', 'teacher', 'executivedirector'],
    },
    {
        path: PageRoute.SyncUser,
        element: <SyncUser />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.ViewUser,
        element: <Viewuser />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.Usercreated,
        element: <Usercreated />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.DashboardView,
        element: <ViewEmp />,
        roles: ['manager', 'admin', 'executivedirector'],
    },
    {
        path: PageRoute.ViewEmpDetail,
        element: <EmpDetails />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.AddTimeRequest,
        element: <AddTime />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.LeavePolicy,
        element: <LeavePolicy />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.EditPolicy,
        element: <EditPolicy />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Signup,
        element: <Signup />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Files,
        element: <EmpFiles />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.FileUpload,
        element: <UploadFile />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.FileEdit,
        element: <UploadFile />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.LeaveTypes,
        element: <LeaveTypes />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Resouces,
        element: <Resources />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.Forms,
        element: <Forms />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.EmployeeForm,
        element: <FormTable />,
        roles: ['manager', 'teacher', 'executivedirector'],
    },
    {
        path: PageRoute.UplaodForm,
        element: <UploadForm />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.EditForm,
        element: <UploadForm />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.AssignUserForm,
        element: <AssignUsers />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.EmployeeResouces,
        element: <EmpResources />,
        roles: ['teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.ViewResouce,
        element: <ViewResource />,
        roles: ['teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.Questions,
        element: <Questionnaire />,
        roles: ['teacher', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.AssignResouces,
        element: <AssignResources />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.ExporeResource,
        element: <ExploreResource />,
        roles: ['admin', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.UploadRsrc,
        element: <UploadResources />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.CreateQues,
        element: <CreateQuestion />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.OtherTimeReq,
        element: <Applyrequest />,
        roles: ['admin', 'manager', 'executivedirector'],
    },
    {
        path: PageRoute.UserPassword,
        element: <ChangePassword />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.SynCalendar,
        element: <SyncTable />,
        roles: ['admin', 'executivedirector'],
    },
    {
        path: PageRoute.Notification,
        element: <Notification />,
        roles: ['admin', 'teacher', 'manager', 'executivedirector'],
    },
]

const AppRoutes: React.FC = () => {
    const dispatch = useAppSelector(selectAuth)
    const { role } = useAppSelector((state) => state.persistedReducers.user)
    return (
        <Routes>
            {publicRoutes.map((route, index) => (
                <Route
                    key={index}
                    path={route.path}
                    element={
                        dispatch.isUser ? (
                            <Navigate to={PageRoute.Dashboard} replace />
                        ) : (
                            route.element
                        )
                    }
                />
            ))}
            {dispatch.isUser && (
                <>
                    {protectedRoutes.map((route, index) => {
                        const allowedRoles = route.roles as string[]
                        if (
                            allowedRoles.includes(
                                role?.replace(/\s+/g, '').toLowerCase()
                            )
                        ) {
                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    element={route.element}
                                />
                            )
                        }
                        return null
                    })}
                </>
            )}
            {!dispatch.isUser && (
                <Route
                    path="*"
                    element={<Navigate to={PageRoute.Login} replace />}
                />
            )}
        </Routes>
    )
}

export default AppRoutes
